import StatusCard from "components/StatusCard";
import SettingsForm from "components/admin/SettingsForm";
import ProfileCard from "components/admin/ProfileCard";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import Loader from "components/Loader";
import { useState } from "react";
import { setMemberLoading } from "actions/memberActions";
import apiClient from "utils/apiClient";
import { resetErrors } from "actions/flashMessagesAction";

export default function DashboardAdmin() {
  const { loading } = useSelector((state) => state.members);

  const [resellerCount, setResellerCount] = useState("0");
  const [resellerCountMonth, setResellerCountMonth] = useState("0");
  const [memberCount, setMemberCount] = useState("0");
  const [memberCountMonth, setMemberCountMonth] = useState("0");

  const dispatch = useDispatch();

  const member_count = () => {
    dispatch(setMemberLoading());
    const url = "/api/admin/all/count";
    apiClient()
      .get(url)
      .then((res) => {
        setResellerCount(res.data.resellerAll);
        setResellerCountMonth(res.data.resellersMonth);
        setMemberCount(res.data.memberAll);
        setMemberCountMonth(res.data.memberMonth);
      })
      .catch((err) => console.log(err.response.data));
    dispatch(setMemberLoading("false"));
  };

  useEffect(() => {
    member_count();
  }, [dispatch]);

  useEffect(() => {
    dispatch(resetErrors());
  }, []);
  //let setAmount;
  // if (loading) {
  //   setAmount = <Loader />;
  // } else {
  //   setAmount = walletAmount ? `$${walletAmount}` : "0";
  // }

  return (
    <>
      <div className="bg-light-blue-500 pt-14 pb-28 px-3 md:px-8 h-auto">
        <div className="container mx-auto max-w-full">
          <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4">
            <StatusCard
              color="pink"
              icon="trending_up"
              title="Resellers"
              amount={loading ? <Loader /> : resellerCount.toString()}
              percentage=""
              percentageIcon=""
              percentageColor="green"
              date="Total till now"
            />
            <StatusCard
              color="orange"
              icon="groups"
              title="New Resellers"
              amount={loading ? <Loader /> : resellerCountMonth.toString()}
              percentage=""
              percentageIcon=""
              percentageColor="red"
              date="Since last month"
            />
            <StatusCard
              color="blue"
              icon="poll"
              title="Members"
              amount={loading ? <Loader /> : memberCount.toString()}
              percentage=""
              percentageIcon=""
              percentageColor="green"
              date="In Total"
            />
            <StatusCard
              color="purple"
              icon="paid"
              title="Members"
              amount={loading ? <Loader /> : memberCountMonth.toString()}
              percentage=""
              percentageIcon=""
              percentageColor="orange"
              date="Since last month"
            />
          </div>
        </div>
      </div>

      <div className="px-3 md:px-8 h-auto -mt-24">
        <div className="container mx-auto max-w-full">
          <div className="grid grid-cols-1 xl:grid-cols-6">
            <div className="xl:col-start-1 xl:col-end-5 px-4 mb-16">
              <SettingsForm />
            </div>
            {/* <div className="xl:col-start-5 xl:col-end-7 px-4 mb-16 mt-14">
              <ProfileCard walletAmount="" loading="" />
            </div> */}
          </div>
        </div>
      </div>
    </>
  );
}
